import { memo, ReactElement, ReactNode } from 'react';
import { CSSProperties } from '@mui/styles';
import ClickableTooltip from './clickableTooltip';
import StandardTooltip from './standardTooltip';
import { getDeviceType } from '../../../constants/helpers/deviceType';
import { Placement } from './types';

interface Props {
  children: ReactElement<any, any>;
  title: NonNullable<ReactNode>;
  offset?: [CSSProperties['offset'], CSSProperties['offset']];
  placement?: Placement;
}

const Tooltip = ({ children, title, placement = 'bottom', offset }: Props) => {
  const deviceType = getDeviceType();

  if (deviceType === 'touched') {
    return (
      <ClickableTooltip title={title} offset={offset} placement={placement}>
        {children}
      </ClickableTooltip>
    );
  }
  return (
    <StandardTooltip placement={placement} title={title} offset={offset}>
      {children}
    </StandardTooltip>
  );
};

export default memo(Tooltip);
